import { HeaderBar } from "routes/schedule/compare/header-bar"
import { registerComparitor } from "routes/schedule/compare/register-comparitor"
import { TextDifference } from "routes/schedule/compare/text-difference"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_CLIENT_SCHEDULE_FIELDS } from "./server/feature-flag-client-schedule-fields.mjs"

registerComparitor("clientCustomField", renderClientCustomFieldDifference)
registerComparitor("clientReferenceTag", renderClientReferenceTagDifference)

// Unlike title/intro these fields are optional, so the comparitor also runs when the
// path is absent on both sides. Returning null is register-comparitor's explicit
// "no difference" signal: nothing is pushed into the comparison, so unflagged and
// legacy schedules gain no entries (not even invisible ones).
function renderClientCustomFieldDifference({ v1, v2 }) {
    if (!shouldRenderDifference(v1, v2)) return null
    return (
        <HeaderBar label="Client Fields">
            <TextDifference path="clientCustomField" label="custom field" />
        </HeaderBar>
    )
}

function renderClientReferenceTagDifference({ v1, v2 }) {
    if (!shouldRenderDifference(v1, v2)) return null
    return (
        <HeaderBar label="Client Fields">
            <TextDifference path="clientReferenceTag" label="reference tag" />
        </HeaderBar>
    )
}

function shouldRenderDifference(v1, v2) {
    return isEnabled(FEATURE_FLAG_CLIENT_SCHEDULE_FIELDS) && (v1 ?? "") !== (v2 ?? "")
}
